import { FETCH_ITEM_COPIES, EDIT_ITEM_COPY, DESTROY_ITEM_COPY } from '../actionTypes';

const getItemCopies = (state = [], action) => {
    switch (action.type) {
        case FETCH_ITEM_COPIES:
            state = [];
            return [...state, ...action.copies];

        case EDIT_ITEM_COPY:
            return state.map(copy => {
                if (copy.id === action.copy.id) {
                    return {
                        ...copy,
                        ...action.copy
                    };
                }

                return copy;
            });

        case DESTROY_ITEM_COPY:
            return state[action.key] = [];

        default:
            return state;
    }

};

export default getItemCopies;